// eslint-disable-next-line @typescript-eslint/no-empty-function
export const noop = () => {}

export function on<T extends Window | Document | HTMLElement | EventTarget>(
    obj: T | null,
    // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
    ...args: Parameters<T['addEventListener']> | [string, Function | null, ...any]
): void {
    if (obj?.addEventListener) {
        obj.addEventListener(...(args as Parameters<HTMLElement['addEventListener']>))
    }
}

export function off<T extends Window | Document | HTMLElement | EventTarget>(
    obj: T | null,
    // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
    ...args: Parameters<T['removeEventListener']> | [string, Function | null, ...any]
): void {
    if (obj?.removeEventListener) {
        obj.removeEventListener(...(args as Parameters<HTMLElement['removeEventListener']>))
    }
}

export const isBrowser = typeof window !== 'undefined'

export const isNavigator = typeof navigator !== 'undefined'
